(function ($) {
    $(document).ready(function () {
        if ($('.industries').length > 0 && (!$('.industries').hasClass('text-given'))) {
            industriesClick($('.industry-col').first());
        }

        $('.industry-col').click(function () {

            if (window.matchMedia("(min-width: 992px)").matches) {
                industriesClick($(this));
            }
        });

        function industriesClick($element) {

            $('.industry-col').removeClass('active');
            $element.addClass('active');

            var title = $element.find('h3 .industry-title').text();
            var text = $element.find('.hidden-industry-copy').html();
            var link = $element.find('.industry-link').attr('href');
            var link_text = $element.find('.industry-link .link-text').text();

            $('.chosen-industry h3').text(title);
            $('.chosen-industry p').text(text);
            $('.chosen-industry a ').attr('href', link)
            $('.chosen-industry a ').text(link_text);
            console.log('the link text is' + link_text);
            if (link_text !== "") {
                $('chosen-industry a').show();
            }
            else {
                $('chosen-industry a').hide();

            }


        }
    });
})(jQuery);